import { Field, Float, ID, ObjectType } from 'type-graphql'
import { Customer } from './Customer'
import { Company } from '../company/Company'

@ObjectType()
export class CustomerAndCompany {
  @Field(() => ID)
  _id: string

  @Field(() => Company)
  company: Company

  @Field(() => [Customer])
  customers: [Customer]

  @Field(() => [CustomerAndCompany])
  subCompanies: [CustomerAndCompany]

  @Field(() => Company)
  parentCompany: Company

  @Field(() => Float)
  count: number

  @Field(() => String)
  chosen: boolean
}
